export const COUNTRY: string = process.env.REACT_APP_COUNTRY ?? "";
export const PUBLIC_PATH: string = process.env.REACT_APP_PUBLIC_PATH ?? "";
export const BASE_URL: string = process.env.REACT_APP_BASE_URL ?? "";
export const DEFAULT_LANGUAGE: string = process.env.REACT_APP_DEFAULT_LANGUAGE ?? "en";
export const TRADE_PORTAL_URL: string = process.env.REACT_APP_TRADE_PORTAL_URL ?? "";
export const CRETE_ACCOUNT_LINK: string = process.env.REACT_APP_CRETE_ACCOUNT_LINK ?? "";
export const PROFILE_URL: string = process.env.REACT_APP_PROFILE_URL ?? "";
export const ENV_NAME: string = process.env.REACT_APP_ENV_NAME ?? "uat";
